export const uiSchema = t => {
  return {
    introductionTextDefault: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    introductionTextFullHr: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    introductionTextLineManager: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    introductionTextAdvancedUser: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    introductionTextEmployee: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
  };
};
